/**
 * LC Menu Drawer
 * Custom element for mobile menu drawer with Literary Sport-style animations
 * Features: fade animation, right-aligned content, text toggle, scroll lock
 */

if (!customElements.get('lc-menu-drawer')) {
  customElements.define(
    'lc-menu-drawer',
    class LcMenuDrawer extends HTMLElement {
      constructor() {
        super();
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.scrollPosition = 0;
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onToggle = this.onToggle.bind(this);
        this.onSummaryClick = this.onSummaryClick.bind(this);
      }

      connectedCallback() {
        this.details?.addEventListener('toggle', this.onToggle);
        this.summary?.addEventListener('click', this.onSummaryClick);
        document.addEventListener('keyup', this.onKeyUp);
      }

      disconnectedCallback() {
        this.details?.removeEventListener('toggle', this.onToggle);
        this.summary?.removeEventListener('click', this.onSummaryClick);
        document.removeEventListener('keyup', this.onKeyUp);
      }

      onSummaryClick(event) {
        if (this.details?.hasAttribute('open')) {
          event.preventDefault();
          this.closeWithAnimation();
        }
      }

      onToggle() {
        const isOpen = this.details?.hasAttribute('open');
        this.summary?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        isOpen ? this.lockBodyScroll() : this.unlockBodyScroll();
      }

      closeWithAnimation() {
        this.details?.classList.add('lc-menu-drawer--closing');
        // Wait for slide-out animation (300ms) before removing open state
        setTimeout(() => {
          this.details?.classList.remove('lc-menu-drawer--closing');
          this.details?.removeAttribute('open');
          this.summary?.focus();
        }, 300);
      }

      lockBodyScroll() {
        this.scrollPosition = window.scrollY;
        document.body.classList.add('lc-menu-open');
        document.body.style.top = `-${this.scrollPosition}px`;
      }

      unlockBodyScroll() {
        document.body.classList.remove('lc-menu-open');
        document.body.style.top = '';
        window.scrollTo(0, this.scrollPosition);
      }

      onKeyUp(event) {
        if (event.code === 'Escape' && this.details?.hasAttribute('open')) {
          this.closeWithAnimation();
        }
      }
    }
  );
}
